'use client';

import * as React from 'react';
import type { User } from '@noirproperties/core/user';

export const UserContext = React.createContext<User | null>(null);

export function UserProvider({
  initialUser,
  children,
}: {
  initialUser: User;
  children: React.ReactNode;
}) {
  return (
    <UserContext.Provider value={initialUser}>{children}</UserContext.Provider>
  );
}
